import React, {
  useState,

  useRef,
  useEffect,
} from 'react';

import { attachmentPreviewPropTypes } from '../../../utils/attachments';
import {
  Container,
  StyledAudio,
  Title,
  ErrorText,
} from './styles';
import texts from './texts.json';

const defaultAudioType = 'audio/mp3';

const AudioError = {
  MEDIA_ERR_ABORTED: 'MEDIA_ERR_ABORTED',
  MEDIA_ERR_NETWORK: 'MEDIA_ERR_NETWORK',
  MEDIA_ERR_DECODE: 'MEDIA_ERR_DECODE',
  MEDIA_ERR_SRC_NOT_SUPPORTED: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
};

const AudioErrorCode = {
  [AudioError.MEDIA_ERR_ABORTED]: 1,
  [AudioError.MEDIA_ERR_NETWORK]: 2,
  [AudioError.MEDIA_ERR_DECODE]: 3,
  [AudioError.MEDIA_ERR_SRC_NOT_SUPPORTED]: 4,
};

const audioErrorMessages = {
  [AudioErrorCode[AudioError.MEDIA_ERR_ABORTED]]: 'User aborted the audio playback',
  [AudioErrorCode[AudioError.MEDIA_ERR_NETWORK]]: 'Network error',
  [AudioErrorCode[AudioError.MEDIA_ERR_DECODE]]: 'Audio decoding error',
  [AudioErrorCode[AudioError.MEDIA_ERR_SRC_NOT_SUPPORTED]]: 'Audio not supported',
};

const AudioAttachment = ({
  attachmentData,
  assetLocalUrl,
}) => {
  const [error, setError] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => {
    // audio error handling
    const audioReference = audioRef.current;
    if (audioReference) {
      audioReference.onerror = (err) => {
        if (err.target.error) {
          const { code } = err.target.error;
          setError(audioErrorMessages[code] || texts.audioError);
        } else {
          setError(texts.audioError);
        }
      };
    }

    return () => {
      if (audioReference) {
        audioReference.onerror = null;
      }
    };
  }, []);

  return (
    <Container>
      <StyledAudio controls ref={audioRef}>
        <source src={assetLocalUrl} type={attachmentData.mimeType} />
        <source src={assetLocalUrl} type={defaultAudioType} />
      </StyledAudio>
      <Title>{attachmentData.title}</Title>
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
};

AudioAttachment.propTypes = attachmentPreviewPropTypes;

AudioAttachment.defaultProps = {};

export default AudioAttachment;
